import apiClient from "services/apiClient";

async function deleteObservation(id: any) {
  const res = await apiClient.delete(`/admin/observations/${id}`, );
  return res.data;
}

export default deleteObservation;
